var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 193,
    viewBox: "0 0 221 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 83,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1664_41506)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 52.3048C105.039 50.8015 110.247 50.7643 115.14 52.1978L201.676 77.5467C207.399 79.2232 207.437 87.3173 201.729 89.0469L115.378 115.214C110.337 116.742 104.95 116.702 99.9323 115.101L18.214 89.0202C12.618 87.2343 12.6564 79.3026 18.2695 77.5709L100.166 52.3048Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.661 27.8888L133.006 19.6112L114.75 29.8775V9.5H105.25V29.8775L86.9941 19.6112L82.3391 27.8888L100.313 38L82.3391 48.1112L86.9941 56.3888L105.25 46.1225V66.5H114.75V46.1225L133.006 56.3888L137.661 48.1112L119.687 38L137.661 27.8888Z",
    fill: "#BDCEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110 15.8334C113.498 15.8334 116.333 12.9979 116.333 9.50008C116.333 6.00228 113.498 3.16675 110 3.16675C106.502 3.16675 103.667 6.00228 103.667 9.50008C103.667 12.9979 106.502 15.8334 110 15.8334Z",
    fill: "url(#paint1_linear_1664_41506)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.333 30.0834C138.831 30.0834 141.667 27.2479 141.667 23.7501C141.667 20.2523 138.831 17.4167 135.333 17.4167C131.836 17.4167 129 20.2523 129 23.7501C129 27.2479 131.836 30.0834 135.333 30.0834Z",
    fill: "url(#paint2_linear_1664_41506)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6666 30.0834C88.1644 30.0834 90.9999 27.2479 90.9999 23.7501C90.9999 20.2523 88.1644 17.4167 84.6666 17.4167C81.1688 17.4167 78.3333 20.2523 78.3333 23.7501C78.3333 27.2479 81.1688 30.0834 84.6666 30.0834Z",
    fill: "url(#paint3_linear_1664_41506)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110 72.8333C113.498 72.8333 116.333 69.9978 116.333 66.5C116.333 63.0022 113.498 60.1666 110 60.1666C106.502 60.1666 103.667 63.0022 103.667 66.5C103.667 69.9978 106.502 72.8333 110 72.8333Z",
    fill: "url(#paint4_linear_1664_41506)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6666 58.5833C88.1644 58.5833 90.9999 55.7478 90.9999 52.25C90.9999 48.7522 88.1644 45.9166 84.6666 45.9166C81.1688 45.9166 78.3333 48.7522 78.3333 52.25C78.3333 55.7478 81.1688 58.5833 84.6666 58.5833Z",
    fill: "url(#paint5_linear_1664_41506)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.333 58.5833C138.831 58.5833 141.667 55.7478 141.667 52.25C141.667 48.7522 138.831 45.9166 135.333 45.9166C131.836 45.9166 129 48.7522 129 52.25C129 55.7478 131.836 58.5833 135.333 58.5833Z",
    fill: "url(#paint6_linear_1664_41506)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110 47.5C115.247 47.5 119.5 43.2467 119.5 38C119.5 32.7533 115.247 28.5 110 28.5C104.753 28.5 100.5 32.7533 100.5 38C100.5 43.2467 104.753 47.5 110 47.5Z",
    fill: "url(#paint7_linear_1664_41506)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1664_41506",
    x1: 206,
    y1: 138,
    x2: 14,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1664_41506",
    x1: 110,
    y1: 3.16675,
    x2: 110,
    y2: 15.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1664_41506",
    x1: 135.333,
    y1: 17.4167,
    x2: 135.333,
    y2: 30.0834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1664_41506",
    x1: 84.6666,
    y1: 17.4167,
    x2: 84.6666,
    y2: 30.0834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1664_41506",
    x1: 110,
    y1: 60.1666,
    x2: 110,
    y2: 72.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1664_41506",
    x1: 84.6666,
    y1: 45.9166,
    x2: 84.6666,
    y2: 58.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1664_41506",
    x1: 135.333,
    y1: 45.9166,
    x2: 135.333,
    y2: 58.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1664_41506",
    x1: 110,
    y1: 28.5,
    x2: 110,
    y2: 47.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.24d7d10f8a1dba95cc3e7cc6685de3aa.svg";
export { ForwardRef as ReactComponent };